import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useGenerateIncentiveOfferPurchaseContractModal } from './context/GenerateIncentiveOfferPurchaseContractModalContext';
import GenerateIncentiveOfferPurchaseContractModalHeader from './components/GenerateIncentiveOfferPurchaseContractModalHeader';
import GenerateIncentiveOfferPurchaseContractModalBody from './components/GenerateIncentiveOfferPurchaseContractModalBody';
import GenerateIncentiveOfferPurchaseContractModalFooter from './components/GenerateIncentiveOfferPurchaseContractModalFooter';

const GenerateIncentiveOfferPurchaseContractModal: FC = () => {
  const { data } = useGenerateIncentiveOfferPurchaseContractModal();

  return (
    <>
      <GenerateIncentiveOfferPurchaseContractModalHeader />
      <GenerateIncentiveOfferPurchaseContractModalBody />
      <GenerateIncentiveOfferPurchaseContractModalFooter />
      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default GenerateIncentiveOfferPurchaseContractModal;
